import React, { useContext, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Pathname } from 'Routes';
import { AppContext } from 'Context';
import logo from 'Assets/Login Logo.png';
import LightRays from 'Components/reactbits/LightRays';
import { isNewUIEnabled } from 'hooks/useNewUI';
import InivteGrp from '../../../../Assets/InivteGrp.png';
import AppStore from '../../../../Assets/app-store.png';
import Apple from '../../landing-external/assets/img/appstore2.svg';
import Roku from '../../landing-external/assets/img/roku.svg';
import FireTv from '../../landing-external/assets/img/fire-tv.svg';
import Googletv from '../../landing-external/assets/img/google-cast.svg';
import GooglePlay from '../../landing-external/assets/img/playstore.svg';
import UploadStatus from './UploadStatus';
import styles from './DeviceList.module.css';
import { DeviceListClassic } from './DeviceListClassic';

const DeviceListNew = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const uploadPercentages = useSelector((state) => state.upload);
  console.log('uploadPercentages', uploadPercentages);

  // Detect active uploads
  const activeUploads = Object.entries(uploadPercentages).filter(
    ([_, progress]) => progress !== null && progress !== undefined && progress !== 'Please wait'
  );
  const hasActiveUploads = activeUploads.length > 0;

  const { setAppSnackbar, setNeedToShowETA } = useContext(AppContext);
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };
  useEffect(() => {
    // callForUpdate();
    setNeedToShowETA(false);
  }, []);
  const suffix = getQueryParam('email');

  // Device click handlers
  const platforms = [
    {
      name: 'Roku',
      url: 'https://channelstore.roku.com/details/e6a1063fcdc0af86bea4707c2b889700:a838d0bb3d0551f9cb7d15cfc993f595/projector',
      image: Roku,
    },
    {
      name: 'Google TV',
      url: 'https://play.google.com/store/apps/details?id=com.projectorllc.projectorapptv',
      image: Googletv,
    },
    {
      name: 'Fire TV',
      url: 'https://www.amazon.com/Projector-LLC/dp/B09TG4ZDJ2/ref=sr_1_1?crid=1NQQX43KDWAX8&dib=eyJ2IjoiMSJ9.XgwdOPTL3iVFzBVnU4OntRPSKtSRiLX4zqhS_M34_6T8z3oblbBdbpunkuQEs84kpQwWW98fSAmNKdS08CjZKTS4kjzPXg_q8xA7KSyy6w_BPVDXtzSHb4UA1if6uRM1B8D0a6GqSdwegUR4l_X1Gg5yLyMVs4Qy5HhhFY26CenvorlZPdH5Fe4-QKN-n1IhfinNfzuETIkEzNjeTL6FzZY9FvQOqZe72WXjm8pQ9Fj8QUwBfcJ9Bsx9J-NVvEdYFZPUZYctBKgXxobiB6RWw87GhVwwvanx0IsIDK3bCIU.g_p6LDfgCwCXPmLcBUHif33V-0ok_KmtIeRNu6VkUyg&dib_tag=se&keywords=projector+app&qid=1758222291&s=mobile-apps&sprefix=projector+app%2Cmobile-apps%2C149&sr=1-1',
      image: FireTv,
    },
    {
      name: 'Android',
      url: 'https://play.google.com/store/apps/details?id=com.projectorllc.projectorapp',
      image: GooglePlay,
    },
    {
      name: 'Appstore',
      url: 'https://apps.apple.com/in/app/projector-stream/id1585850104',
      image: AppStore,
    },
    {
      name: 'Apple TV',
      url: 'https://apps.apple.com/in/app/projector-stream/id1585850104',
      image: Apple,
    },
  ];

  const frontEnd = [
    {
      title: 'Watch On All Your Devices',
      subtitle:
        'Create a Projector and have the ultimate viewing experience for your own \nmemories like never before! \nClick here to start uploading.',
      image: InivteGrp,
      buttonText: 'CLICK HERE TO DOWNLOAD',
      navigation: Pathname.plans,
    },
  ];
  // "Watch on my projector" handler. New-signup flow goes straight to /profile
  // in the SAME tab (no new tab, no welcome page). Gift / everyone else keep the
  // original behaviour (open /profile in a new tab + navigate this tab onward).
  const handleWatchOnProjector = () => {
    if (location.state?.isNewSignupFlow) {
      navigate(Pathname.profile.basePath);
      return;
    }
    const isGift = !!(location.state?.isGiftFlow || getQueryParam('gift') === 'true');
    window.open(isGift ? '/profile?fromGift=true' : '/profile', '_blank');
    navigate(
      isGift ? `${Pathname.yourVideos}?fromGift=true` : Pathname.authentication.toTrail,
      { state: { isGiftFlow: isGift } },
    );
  };

  const values = Object.values(uploadPercentages);

  // "Please wait" means finished, everything else is current
  const current = values.filter((v) => v !== 'Please wait').length;
  const total = values.length;

  const isGiftFlow = !!(
    location.state?.isGiftFlow
    || new URLSearchParams(location.search).get('fromGift') === 'true'
    || new URLSearchParams(location.search).get('gift') === 'true'
  );

  const openPlatform = (platform) => {
    if (platform.disable) return;
    window.open(platform.url, '_blank');
  };

  const goToInvite = () => navigate(`${Pathname.authentication.invite}${suffix ? `?email=${suffix}` : ''}`);

  return (
    <div className={styles.page}>
      {/* The login screen's backdrop: volumetric light rays over the near-black
          base, props identical to /newSign-in so both read as one surface. */}
      <div className={styles.rays} aria-hidden="true">
        <LightRays
          raysOrigin="top-center"
          raysColor="#ffffff"
          raysSpeed={0.9}
          lightSpread={0.85}
          rayLength={1.25}
          fadeDistance={1.1}
          saturation={1}
          followMouse
          mouseInfluence={0.08}
          noiseAmount={0.08}
          distortion={0.04}
        />
      </div>
      <div className={styles.glow} aria-hidden="true" />

      {/* Back button for gift flow */}
      {isGiftFlow && (
        <div
          aria-hidden="true"
          onClick={() => navigate(-1)}
          className={styles.backLink}
        >
          Back
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.masthead}>
          <Link to={Pathname.home} className={styles.logoLink}>
            <img className={styles.logoImage} src={logo} alt="projector logo" />
          </Link>
          {Object.keys(uploadPercentages).length > 0 && (
            <UploadStatus current={current} total={total} />
          )}
        </div>

        {frontEnd?.map((obj, index) => (
          <React.Fragment key={index}>
            <div className={styles.hero}>
              <h1 className={styles.title}>{obj?.title}</h1>
              <p className={styles.subheading}>
                Get Projector on your TV, Phone and Tablet
              </p>
              <p className={styles.lead}>
                What device do you want to download projector on ?
              </p>
            </div>

            <div className={styles.gridHead}>
              <span className={styles.gridHeadRule} aria-hidden="true" />
              <span className={styles.gridHeadText}>Choose your platform</span>
              <span className={styles.gridHeadRule} aria-hidden="true" />
            </div>

            <div className={styles.deviceGrid}>
              {platforms.map((platform) => (
                <div
                  key={platform.name}
                  className={styles.deviceItem}
                  onClick={() => openPlatform(platform)}
                  role="button"
                  tabIndex={platform.disable ? -1 : 0}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openPlatform(platform); }}
                  aria-label={`Download Projector for ${platform.name}`}
                  style={platform.disable ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
                >
                  <img className={styles.deviceIcon} src={platform.image} alt={platform.name} />
                  <span className={styles.deviceLabel}>{platform.name}</span>
                </div>
              ))}
            </div>

            {/* Uploading Notification */}
            {hasActiveUploads && (
              <div className={styles.uploadingNotification}>
                <span className={styles.uploadingPulse} aria-hidden="true" />
                <span className={styles.uploadingText}>Uploading your files</span>
                <span className={styles.uploadingDots} aria-hidden="true">
                  <span className={styles.uploadingDot1}>.</span>
                  <span className={styles.uploadingDot2}>.</span>
                  <span className={styles.uploadingDot3}>.</span>
                </span>
              </div>
            )}

            <div className={styles.actions}>
              <button
                type="button"
                className={styles.primary}
                onClick={handleWatchOnProjector}
              >
                <span className={styles.hideOnMobile}>Watch on your Computer</span>
                <span className={styles.showOnMobileOnly}>View Your Projector</span>
              </button>
              {!location.state?.isGiftFlow && getQueryParam('gift') !== 'true' && (
                <button
                  type="button"
                  className={styles.secondary}
                  onClick={goToInvite}
                >
                  Next
                </button>
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

/**
 * /ecosystem device list — part of the new-user signup flow, so it follows the
 * same gate as the rest of that lane.
 */
export const DeviceList = (props) => (
  isNewUIEnabled() ? <DeviceListNew {...props} /> : <DeviceListClassic {...props} />
);

export default DeviceList;
